import { NavigationItem } from "./NavigationItem";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { NavBack as NavBackItem } from "../../HTML/Navigation/NavBack";

export class NavBack extends NavigationItem {
    protected createTag(data: any) {
        this.addToData("tag", new NavBackItem(data));
    }
}

ControllerRegistry.register("NavBack", NavBack);
